var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17 7L22 12M22 12L17 17M22 12L8 12M8 2L4 2C3.33333 2 2 2.4 2 4C2 5.6 2 15.3333 2 20C2 20.6667 2.4 22 4 22C5.6 22 7.33333 22 8 22","stroke":"black","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }